import { mapActions, mapMutations, mapState } from 'vuex'
import { CONTACTS_VIEW_MODE } from '@/common/const/contacts.const'

export default {
  computed: {
    ...mapState({
      viewMode: state => state.contacts.viewMode,
      isLoading: state => state.contacts.loading
    }),
    isViewModeList: function () {
      return this.viewMode === CONTACTS_VIEW_MODE.list
    },
    isViewModeFormAdd: function () {
      return this.viewMode === CONTACTS_VIEW_MODE.formAdd
    }
  },
  methods: {
    ...mapMutations([
      'SET_CONTACTS_VIEW_MODE'
    ]),
    ...mapActions([
      'getContacts'
    ]),
    setViewModeFormAdd () {
      this.SET_CONTACTS_VIEW_MODE(CONTACTS_VIEW_MODE.formAdd)
    },
    setViewModeList () {
      this.SET_CONTACTS_VIEW_MODE(CONTACTS_VIEW_MODE.list)
    }
  },
  mounted () {
    this.getContacts()
  }
}
